// Single home for the session JWT so every consumer (axios interceptors,
// AuthContext, embed bootstrap, direct fetch() callers) agrees on where it
// lives.
//
// The /embed/* surface (Salesforce iframe) stores its short-lived viewer token
// in sessionStorage under its own key: an embed link opened in a browser where
// a staff member is logged in must never clobber the real session in
// localStorage, and sessionStorage keeps each iframe/tab isolated.

const TOKEN_KEY = 'lpc_rdh_token';
const EMBED_TOKEN_KEY = 'lpc_rdh_embed_token';

const isEmbed = () => window.location.pathname.startsWith('/embed');

export function getToken() {
  return isEmbed() ? sessionStorage.getItem(EMBED_TOKEN_KEY) : localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (isEmbed()) {
    sessionStorage.setItem(EMBED_TOKEN_KEY, token);
  } else {
    localStorage.setItem(TOKEN_KEY, token);
  }
}

export function clearToken() {
  if (isEmbed()) {
    sessionStorage.removeItem(EMBED_TOKEN_KEY);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
}
